/**
 * Legal-entity facts for EchoSense Capital Markets, LLC — single source of
 * truth for every component that renders formation details. If a formation
 * detail ever changes, update it here only.
 *
 * SCOPE NARROWED 2026-07-23 (STARSEED-CAPMARKETS-055): these facts are NO
 * LONGER rendered in the public site footer. The footer now discloses
 * `DISCLOSED_ENTITY` below (club trade name + Kamas address) on partner
 * direction, so the only remaining consumer of the formation facts is the
 * Compliance ID Card — the authenticated artifact that answers "who runs
 * echosensecapital.com" for banks and KYC reviewers. The SumSub
 * entity-identification requirement that originally motivated a public
 * footer disclosure is now satisfied by that card alone; see 055's
 * failure-modes section, which records that trade-off on the record.
 *
 * VERBATIM HOLD (2026-07-02, STARSEED-CAPMARKETS-010), amended 2026-07-21
 * (STARSEED-CAPMARKETS-055): the q-spelling "EqhoSense" → "EchoSense" swap was
 * approved by the operator on 2026-07-21, so the name below now carries the
 * c-spelling. The remaining formation facts (jurisdiction, file number, EIN,
 * registered agent) stay verbatim — they identify the incorporated entity on
 * the Compliance ID Card, which exists to satisfy the KYC provider's
 * entity-identification requirement.
 */
export const LEGAL_ENTITY = {
  name: "EchoSense Capital Markets, LLC",
  jurisdiction: "Wyoming, USA",
  jurisdictionShort: "Wyoming LLC",
  fileNo: "2026-001978324",
  ein: "42-2482851",
  address: "3168 Redwood Street, Las Vegas, NV 89146, USA",
  registeredAgent:
    "Buffalo Registered Agents LLC, 412 N Main St Ste 100, Buffalo, WY 82834",
};

/**
 * Public-facing entity disclosure for the site footer (STARSEED-CAPMARKETS-055,
 * unblocked 2026-07-23 per Jeff's directive via Kevin — "Website Donny Hensley
 * Comments" email): the footer discloses "EchoSense Capital Club" with Jeff's
 * Kamas, UT address, with the Wyoming filing number / EIN dropped from the
 * public render. The incorporated entity's formation facts above are retained
 * unchanged for the Compliance ID Card so the KYC-identification artifact
 * keeps naming the registered entity, not the club trade name.
 */
export const DISCLOSED_ENTITY = {
  name: "EchoSense Capital Club",
  address: "1050 Rusty Circle, Kamas, UT 84036, USA",
};
